import { render } from "./FreeShippingProgression.vue?vue&type=template&id=49d74d62"
import script from "./FreeShippingProgression.vue?vue&type=script&lang=js"
export * from "./FreeShippingProgression.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__